import React, { useState, useEffect } from 'react'
import { Table } from 'reactstrap'
import { addData, deleteIdData, getDataWithType, updateData } from '../../lib/studentassesment'
import { ScoreModal } from './ScoreModal'
import { GoalsRecommendation } from './GoalsRecommendation'
import style from './GoalQuestionsStyles.module.css'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

export const COURSE_TYPES = {
	sat: 'sat',
	apcourse: 'apcourse',
	hrcourse: 'hrcourse'
}

export const ScoreTable = ({ slug, isProfile = false, plain = false }) => {
	const [data, setData] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [modalType, setModalType] = useState('add')
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)
	const [formData, setFormData] = useState({
		id: null,
		studentId: slug,
		assdate: '',
		coursetest: '',
		score: '',
		goal: '',
		grade: null,
		type: COURSE_TYPES.sat
	})

	async function GetData() {
		try {
			const result = await getDataWithType('sat')
			setData(result)
		} catch (error) {
			console.error('Error fetching data:', error)
		}
	}

	useEffect(() => {
		GetData()
	}, [slug])

	// Group data by date and calculate totals
	const groupedData = () => {
		const sortedData = [...data].filter((row) => row.studentId === slug).sort((a, b) => new Date(a.assdate) - new Date(b.assdate))

		const groups = []
		let currentDate = null
		let currentGroup = []

		sortedData.forEach((row) => {
			if (row.assdate !== currentDate) {
				if (currentGroup.length > 0) {
					groups.push(currentGroup)
				}
				currentDate = row.assdate
				currentGroup = [row]
			} else {
				currentGroup.push(row)
			}
		})

		if (currentGroup.length > 0) {
			groups.push(currentGroup)
		}

		return groups.map((group) => {
			const totalScore = group.reduce((acc, row) => acc + (parseFloat(row.score) || 0), 0)
			const totalGoal = group.reduce((acc, row) => acc + (parseFloat(row.goal) || 0), 0)

			return {
				date: group[0].assdate,
				rows: group,
				totalScore,
				totalGoal
			}
		})
	}

	const handleOpenModal = (type, row = null) => {
		setModalType(type)
		setFormData(
			type === 'edit' && row
				? row
				: {
						studentId: slug,
						assdate: '',
						coursetest: '',
						score: 0,
						goal: 0,
						type: 'sat'
				  }
		)
		setShowModal(true)
	}

	const toggleModal = () => setShowModal(!showModal)

	const handleChange = (e) => {
		const { name, value } = e.target
		setFormData((prev) => ({ ...prev, [name]: value }))
	}

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const handleSave = async () => {
		try {
			if (modalType === 'edit') {
				await updateData(formData)
			} else {
				await addData(formData)
			}
			await GetData()
			
			showToastMessage(modalType === 'edit' ? 'Score updated successfully!' : 'Score added successfully!')
			toggleModal()
		} catch (error) {
			console.error('Error saving data:', error)
		}
	}

	const handleDelete = async (id) => {
		const choice = window.confirm('Are You Sure?')
		if (choice) {
			try {
				await deleteIdData(id)
				showToastMessage('Score deleted successfully!')
				await GetData()
			} catch (error) {
				console.error('Error deleting data:', error)
			}
		}
	}

	const isStudent = true // Since this is student view

	const renderContent = () => (
		<>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			{!isProfile && (
				<div className="d-flex justify-content-end mb-3">
					<button className="btn btn-primary btn-sm" onClick={() => handleOpenModal('add')}>
						<i className="fa fa-plus me-2"></i>
						Add New Score
					</button>
				</div>
			)}
			<div className={`${style.tableContainer} ${style.SAT_table_container}`}>
				<Table hover responsive className={`${style.SAT_table} mt-3`}>
					<thead>
						<tr>
							<th>Date</th>
							<th>Test</th>
							<th className="text-center">Score</th>
							<th className="text-center text-danger">Goal</th>
							{!isProfile && <th className="text-end">Actions</th>}
						</tr>
					</thead>
					<tbody>
						{groupedData().map((group, idx) => (
							<React.Fragment key={idx}>
								{group.rows.map((row) => (
									<tr key={row.id}>
										<td>{row.assdate}</td>
										<td>{row.coursetest}</td>
										<td className="text-center">{row.score}</td>
										<td className="text-center text-danger fw-bold">{row.goal}</td>
										{!isProfile && (
											<td className="text-end">
												<button className="btn btn-success btn-sm me-2" onClick={() => handleOpenModal('edit', row)}>
													<i className="fa fa-edit me-1"></i>
												</button>
												<button className="btn btn-danger btn-sm" onClick={() => handleDelete(row.id)}>
														<i className="fa fa-trash"></i>
												</button>
											</td>
										)}
									</tr>
								))}
								<tr className="table-secondary">
									<td className="fw-bold">{group.date}</td>
									<td className="fw-bold">TOTAL</td>
									<td className="text-center fw-bold">{group.totalScore}</td>
									<td className="text-center text-danger fw-bold">{group.totalGoal}</td>
									{!isProfile && <td></td>}
								</tr>
							</React.Fragment>
						))}
					</tbody>
				</Table>
			</div>

			{/* Add Goals Recommendation inside SAT card - only in profile view */}
			{isProfile && (
				<div className="mt-4">
					<GoalsRecommendation slug={slug} isProfile={isProfile} isStudent={isStudent} />
				</div>
			)}

			<ScoreModal
				isOpen={showModal}
				toggle={toggleModal}
				handleChange={handleChange}
				handleSave={handleSave}
				formData={formData}
				modalType={modalType}
			/>
		</>
	)

	if (plain) {
		return renderContent()
	}

	return (
		<div className={`${style.SAT_container}`}>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<div className="card shadow-sm mb-4" style={{ borderRadius: '8px' }}>
				<div className="card-header border-bottom d-flex justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						{!isProfile && (
							<button
								type="button"
								className="btn btn-link p-0 me-2"
								data-bs-toggle="collapse"
								data-bs-target="#collapseSAT"
								aria-expanded="false"
								aria-controls="collapseSAT"
							>
								<i className="fa fa-chevron-down"></i>
							</button>
						)}
						<h5 className="mb-0 d-inline-block">SAT</h5>
					</div>
				</div>
				<div className={isProfile ? '' : 'collapse'} id="collapseSAT">
					<div className="card-body">
						{renderContent()}
					</div>
				</div>
			</div>
		</div>
	)
}
